import { NoddiTimeField } from '@ui-components/Inputs/NoddiTimeField';
import type { ComponentProps } from 'react';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<
  ComponentProps<typeof NoddiTimeField>,
  'value' | 'defaultValue' | 'onChange' | 'onBlur' | 'name' | 'aria-invalid'
>;

export const TanstackFormTime = (props: Props) => {
  const field = useFieldContext<string | undefined>();
  const aria = useTanstackFieldAria(field, props['aria-describedby']);

  return (
    <div>
      <NoddiTimeField
        {...props}
        name={field.name}
        value={field.state.value ?? ''}
        onChange={field.handleChange}
        onBlur={field.handleBlur}
        aria-invalid={aria['aria-invalid']}
        aria-describedby={aria['aria-describedby']}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
